import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../common/redux/store';
import { DEFAULT_SEARCH_VALUE } from './constant';
import { IAdminSearchParams, IAdminSearchState } from './interface';

const initialState: IAdminSearchState = {
  searchValue: DEFAULT_SEARCH_VALUE,
  listIdDelete: [],
  showPopup: false,
};

export const listAdminReducer = createSlice({
  name: 'listAdmin',
  initialState: initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<IAdminSearchParams>) {
      state.searchValue = action.payload;
    },
    setListIdDelete(state, action: PayloadAction<number[]>) {
      state.listIdDelete = action.payload;
    },
    setShowPopup(state, action: PayloadAction<boolean>) {
      state.showPopup = action.payload;
    },
  },
});

export const { setSearchValue, setListIdDelete, setShowPopup } = listAdminReducer.actions;

export const searchValue = (state: RootState) => state.listAdmin.searchValue;
export const listIdDelete = (state: RootState) => state.listAdmin.listIdDelete;
export const showPopup = (state: RootState) => state.listAdmin.showPopup;

export default listAdminReducer.reducer;
